$( document ).ready(function() {
  var originalPrice;
  var originalPriceNeat;
  var originalPriceNeatInt;
  var extrasPrice;
  var extrasPriceInt;
  var totalPrice;
  // Show Personaliser Modal on click
  $('#CustomProductBtn').click(function() {
      $("#CustomProductModal").toggleClass("is-visible");
      $(".customproductmodal__overlay").toggleClass("is-visible");
      $("#CustomProductModal__wrapper").toggleClass("is-visible");
      $("body").toggleClass("modal-open");
      $('html,body').animate({ scrollTop: 0 }, 'slow');
  });
  // Hide Personaliser Modal and update Product Price
  $('.customproductmodal__close, .customproductmodal__closebutton, .customproductmodal__overlay').click(function() {
      $("#CustomProductModal").toggleClass("is-visible");
      $(".customproductmodal__overlay").toggleClass("is-visible");
      $("#CustomProductModal__wrapper").toggleClass("is-visible");
      $("body").toggleClass("modal-open");
      if(document.getElementById("raw_option_total")){
        originalPrice = $(".add-to-cart__price").attr("data-item-price");
        originalPriceNeat = originalPrice.slice(0,-2);
        originalPriceNeatInt = parseInt(originalPriceNeat, 10);
        extrasPrice = $("#raw_option_total").attr("value");
        extrasPriceInt = parseInt(extrasPrice, 10);
        totalPrice = (originalPriceNeatInt + extrasPriceInt);
        $(".add-to-cart__price.money").empty().append("$ " + totalPrice + ".00");
        $(".product__price  .money").empty().append("$ " + totalPrice + ".00");
      }
  });
  // On varient change add currently selected Extras Price to the Product Price
  $(document).on('change','#AddToCartForm .single-option-selector',function(){
      if(document.getElementById("raw_option_total")){
        originalPrice = $(".add-to-cart__price").attr("data-item-price");
        originalPriceNeat = originalPrice.slice(0,-2);
        originalPriceNeatInt = parseInt(originalPriceNeat, 10);
        extrasPrice = $("#raw_option_total").attr("value");
        extrasPriceInt = parseInt(extrasPrice, 10);
        totalPrice = (originalPriceNeatInt + extrasPriceInt);
        $(".add-to-cart__price.money").empty().append("$ " + totalPrice + ".00");
        $(".product__price  .money").empty().append("$ " + totalPrice + ".00");
      }
  });
  
  // Check on Add to Cart no required fields exist
  $('#AddToCart').click(function() {
    setTimeout(
      function() {
        if(document.getElementById("CustomProductModal")){
          if ($("#CustomProductModal .validation_error ").length > 0) {
            $("#CustomProductModal").toggleClass("is-visible");
            $(".customproductmodal__overlay").toggleClass("is-visible");
            $("#CustomProductModal__wrapper").toggleClass("is-visible");
            $("body").toggleClass("modal-open");
            $('html,body').animate({ scrollTop: 0 }, 'slow');
          }
        }
      },
      100);
  });
});

